export const FIELD_FILTER_AT_LEAST_ONE = 'at-least-one';
export const FIELD_FILTER_ALL = 'all';
